import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { checkIfClaimDateIsToday } from '@/common/lib/checkIfClaimDateIsToday';
import { calcTimeToEnableSell } from '@/common/lib/time';
import { type TabBarItemsType } from '@/common/types/components';

interface AppInitialState {
  loginRequestIsLoading: boolean;
  timeToNextSell: number;
  headerHasBlur: boolean;
  tabBarHighlight: TabBarItemsType | null;
  showDailyGoodsLink: boolean;
}

const initialState: AppInitialState = {
  loginRequestIsLoading: true,
  timeToNextSell: calcTimeToEnableSell(),
  headerHasBlur: false,
  tabBarHighlight: null,
  showDailyGoodsLink: checkIfClaimDateIsToday(
    'daily-goods-upgrade-modal-visit',
  ),
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setTimeToNextSell: (state, { payload }: PayloadAction<number>) => {
      state.timeToNextSell = payload;
    },
    changeLoginRequesLoadingStatus: (
      state,
      { payload }: PayloadAction<boolean>,
    ) => {
      state.loginRequestIsLoading = payload;
    },
    changeHeaderBlurStatus: (state, { payload }: PayloadAction<boolean>) => {
      state.headerHasBlur = payload;
    },
    setTabBarHighlight: (
      state,
      { payload }: PayloadAction<TabBarItemsType | null>,
    ) => {
      state.tabBarHighlight = payload;
    },
    changeDailyGoodsLinkStatus: (
      state,
      { payload }: PayloadAction<boolean>,
    ) => {
      state.showDailyGoodsLink = payload;
    },
  },
});

export const {
  setTimeToNextSell,
  changeLoginRequesLoadingStatus,
  changeHeaderBlurStatus,
  setTabBarHighlight,
  changeDailyGoodsLinkStatus,
} = appSlice.actions;
export default appSlice.reducer;
